import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import FigmaApp from './FigmaApp'
import './figma.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found')

createRoot(root).render(
  <StrictMode>
    <FigmaApp />
  </StrictMode>,
)
